/**
 * Ocean Booking API
 *
 * Functions for Ocean Booking CRUD operations.
 * All operations are scoped to the authenticated user's company.
 */

import api from './index';

export const listOceanBookings = (params = {}) => {
  return api.get('/ocean-bookings', { params });
};

export const getOceanBooking = (id) => {
  return api.get(`/ocean-bookings/${id}`);
};

export const createOceanBooking = (data) => {
  return api.post('/ocean-bookings', data);
};

export const updateOceanBooking = (id, data) => {
  return api.put(`/ocean-bookings/${id}`, data);
};

export const updateStatus = (id, status) => {
  return api.patch(`/ocean-bookings/${id}/status`, { status });
};

export const deleteOceanBooking = (id) => {
  return api.delete(`/ocean-bookings/${id}`);
};

export const getStats = (params = {}) => {
  return api.get('/ocean-bookings/stats', { params });
};

export const getCarriers = () => {
  return api.get('/ocean-bookings/carriers');
};
